var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIndustriesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9125 7.6875C36.5257 7.46421 36.0493 7.46421 35.6625 7.6875L25 12.975V8.75C24.9987 8.31676 24.7731 7.91509 24.4039 7.68845C24.0347 7.46182 23.5744 7.44254 23.1875 7.6375L12.5 12.975V3.75C12.5 3.05964 11.9404 2.5 11.25 2.5H3.75C3.05964 2.5 2.5 3.05964 2.5 3.75V35H37.5V8.75C37.5009 8.31812 37.2787 7.91639 36.9125 7.6875ZM27.5 32.5H22.5V23.75H27.5V32.5ZM35 32.5H30V22.5C30 21.8096 29.4404 21.25 28.75 21.25H21.25C20.5596 21.25 20 21.8096 20 22.5V32.5H5V5H10V17.025L22.5 10.775V17.025L35 10.775V32.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIndustriesActive);
export default __webpack_public_path__ + "static/media/ic-industries-active.e2132890.svg";
export { ForwardRef as ReactComponent };